export function zeroPadding(num: number, qty: number) {
  return `${"0".repeat(qty)}${num}`.slice(qty * -1);
}